import { BehaviorSubject, Observable, of } from 'rxjs';
import { tap, map } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { extractResponseBody } from '@app/lib/utils';
import { getSessionData } from '@app/lib/session-data';
import { Role } from '@app/lib/roles.const';
import { ServerApi } from './server-api';

export interface IGroupMapping {
  [key: number]: number[]
}

@Injectable({ providedIn: 'root' })
export class GroupsService {
  private cache$: BehaviorSubject<any> = new BehaviorSubject(null);
  private cacheAncestors$: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private api: ServerApi) {/**/}

  public get groupsChildrenMapping(): IGroupMapping {
    return this.cache$.value;
  }

  public get groupsAncestorMapping(): IGroupMapping {
    return this.cacheAncestors$.value;
  }

  public loadDecendents(): Promise<IGroupMapping> {
    return this.getDecendents().toPromise();
  }

  public getDecendents(): Observable<IGroupMapping> {
    // TODO : Remove this service from FE and add logic to BE to send groups in Validate call
    const { role }: { role: string } = getSessionData();
    if (role !== Role.DISPATCHER) return of({});

    if (this.cache$.value) return of(this.cache$.value);

    const queryParams = new Map();
    queryParams.set('group_ids', null);

    return this.api.get('groups/ancestors/bulk', queryParams)
      .pipe(
        map(extractResponseBody),
        tap((response: IGroupMapping) => {
          this.cacheAncestors$.next(response);
          return response;
        }),
        map(this.transformDecendents),
        tap((response: IGroupMapping) => {
          this.cache$.next(response);
        }),
      );
  }

  public transformDecendents(ancestorsMapping: IGroupMapping): IGroupMapping {
    if (!ancestorsMapping) return {};

    const parentToChild: IGroupMapping = {};
    for (const child of Object.keys(ancestorsMapping)) {
      const parents: number[] = ancestorsMapping[child];
      for (const parent of parents) {
        parentToChild[parent] = parentToChild[parent] || [];
        parentToChild[parent].push(+child);
      }
    }

    return parentToChild;
  }
}